import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMillerColumns = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 6.75C2 5.23122 3.23122 4 4.75 4H18.75C20.2688 4 21.5 5.23122 21.5 6.75V17.75C21.5 19.2688 20.2688 20.5 18.75 20.5H4.75C3.23122 20.5 2 19.2688 2 17.75V6.75ZM14 19V5.5H9.5V19H14ZM15.5 19H18.75C19.4404 19 20 18.4404 20 17.75V6.75C20 6.05964 19.4404 5.5 18.75 5.5H15.5V19ZM4.75 5.5H8V19H4.75C4.05964 19 3.5 18.4404 3.5 17.75V6.75C3.5 6.05964 4.05964 5.5 4.75 5.5Z",
		fill: "currentColor"
	})
});
export { SvgIconMillerColumns as ReactComponent };
